import { render, staticRenderFns } from "./ExclamationMark.vue?vue&type=template&id=00c59e72&scoped=true"
import script from "./ExclamationMark.vue?vue&type=script&lang=js"
export * from "./ExclamationMark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c59e72",
  null
  
)

export default component.exports